import { render } from "./bancard-register.vue?vue&type=template&id=6bf879e4"
import script from "./bancard-register.vue?vue&type=script&lang=js"
export * from "./bancard-register.vue?vue&type=script&lang=js"

import "./bancard-register.vue?vue&type=style&index=0&id=6bf879e4&lang=css"

import exportComponent from "/var/www/html/resources/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__